import styled from 'styled-components';

// @TODO: there is no contentTheme support

const ContentWrapper = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 1rem;
  p {
    font-size: 200%;
    quotes: "“" "”" "‘" "’";
    &::before {
      content: open-quote;
    }
    &::after {
      content: close-quote;
    }
  }
`;

export default ContentWrapper;
